import { useMemo } from 'react';
import { GameTermsContext, getGameTerms } from './gameTerms';

/**
 * Makes a game's custom terms available to every component below it through
 * useGameTerms(). Wrap each page root that renders a single game.
 */
const GameTermsProvider = ({ gameData, children }) => {

  // every game doc snapshot carries a new terms object, so key on its
  // contents to keep the same terms (and stable effect deps) between updates
  const termsKey = JSON.stringify(gameData?.terms ?? {});
  const terms = useMemo(() => getGameTerms({ terms: JSON.parse(termsKey) }), [termsKey]);

  return (
    <GameTermsContext.Provider value={terms}>
      {children}
    </GameTermsContext.Provider>
  )
}

export default GameTermsProvider
